"use strict";
var $a5fd07fa01589658$exports = {};

"use strict";
const $a5fd07fa01589658$var$field = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
class $a5fd07fa01589658$var$Game {
    constructor(initialField = $a5fd07fa01589658$var$field){
        this.gameStatus = "idle";
        this.score = 0;
        this.field = initialField;
    }
    moveLeft() {
        for(let j = 0; j < this.field.length; j++)for(let i = 1; i < this.field[j].length; i++){
            let k = i;
            while(k > 0 && this.field[j][k - 1] === 0){
                this.field[j][k - 1] = this.field[j][k];
                this.field[j][k] = 0;
                k--;
            }
            if (k > 0 && this.field[j][k - 1] === this.field[j][k]) {
                this.score += this.field[j][k - 1] * 2;
                this.field[j][k - 1] *= 2;
                this.field[j][k] = 0;
            }
        }
    }
    moveRight() {
        for(let j = 0; j < this.field.length; j++)for(let i = this.field[j].length - 1; i >= 0; i--){
            let k = i;
            while(k < this.field[j].length - 1 && this.field[j][k + 1] === 0){
                this.field[j][k + 1] = this.field[j][k];
                this.field[j][k] = 0;
                k++;
            }
            if (k < this.field[j].length - 1 && this.field[j][k + 1] === this.field[j][k]) {
                this.score += this.field[j][k + 1] * 2;
                this.field[j][k + 1] *= 2;
                this.field[j][k] = 0;
            }
        }
    }
    moveUp() {
        const size = $a5fd07fa01589658$var$field.length;
        for(let j = 0; j < size; j++){
            let mergeOccurred = false;
            for(let i = 1; i < size; i++)if ($a5fd07fa01589658$var$field[i][j] !== 0) {
                let k = i;
                while(k > 0 && $a5fd07fa01589658$var$field[k - 1][j] === 0){
                    $a5fd07fa01589658$var$field[k - 1][j] = $a5fd07fa01589658$var$field[k][j];
                    $a5fd07fa01589658$var$field[k][j] = 0;
                    k--;
                }
                if (!mergeOccurred && k > 0 && $a5fd07fa01589658$var$field[k - 1][j] === $a5fd07fa01589658$var$field[k][j]) {
                    $a5fd07fa01589658$var$field[k - 1][j] *= 2;
                    $a5fd07fa01589658$var$field[k][j] = 0;
                    mergeOccurred = true;
                }
            }
        }
    }
    moveDown() {
        for(let i = this.field.length - 2; i >= 0; i--)for(let j = 0; j < this.field[i].length; j++){
            let k = i;
            while(k < this.field.length - 1 && this.field[k + 1][j] === 0){
                this.field[k + 1][j] = this.field[k][j];
                this.field[k][j] = 0;
                k++;
            }
            if (k < this.field.length - 1 && this.field[k + 1][j] === this.field[k][j]) {
                this.score += this.field[k + 1][j] * 2;
                this.field[k + 1][j] *= 2;
                this.field[k][j] = 0;
            }
        }
    }
    start() {
        this.addingNumberToField();
        this.addingNumberToField();
        this.gameStatus = "playing";
    }
    restart() {
        this.field = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.addingNumberToField();
        this.addingNumberToField();
        (0, $09e991522ca7e64e$export$65972ef3a64ea716)();
        this.gameStatus = "playing";
        this.score = 0;
        (0, $09e991522ca7e64e$export$c446bd3f79853be8)();
    }
    addingNumberToField() {
        const randomRow = +Math.floor(Math.random() * 4);
        const randomCeil = +Math.floor(Math.random() * 4);
        const firstNum = Math.random() >= 0.9 ? 4 : 2;
        if (!this.field[randomRow][randomCeil]) {
            this.field[randomRow][randomCeil] = firstNum;
            (0, $09e991522ca7e64e$export$65972ef3a64ea716)();
        } else this.addingNumberToField();
    }
    checkVictory() {
        for(let i = 0; i < this.field.length; i++){
            for(let j = 0; j < this.field[i].length; j++)if (this.field[i][j] === 2048) {
                this.gameStatus = "win";
                return true;
            }
        }
        return false;
    }
    canMoveCellsRight() {
        for(let j = 0; j < this.field.length; j++)for(let i = this.field[j].length - 1; i >= 0; i--){
            if (this.field[j][i + 1] === 0 && this.field[j][i] !== this.field[j][i + 1] || this.field[j][i + 1] === this.field[j][i] && this.field[j][i] !== 0) return true;
        }
        return false;
    }
    canMoveCellsLeft() {
        for(let j = 0; j < this.field.length; j++)for(let i = this.field[j].length - 1; i >= 1; i--){
            if (this.field[j][i - 1] === 0 && this.field[j][i] !== this.field[j][i - 1] || this.field[j][i - 1] === this.field[j][i] && this.field[j][i] !== 0) return true;
        }
        return false;
    }
    canMoveCellsUp() {
        for(let i = 1; i < this.field.length; i++)for(let j = 0; j < this.field[i].length; j++){
            if (this.field[i - 1][j] === 0 && this.field[i][j] !== this.field[i - 1][j] || this.field[i - 1][j] === this.field[i][j] && this.field[i][j] !== 0) return true;
        }
        return false;
    }
    canMoveCellsDown() {
        for(let i = 0; i < this.field.length - 1; i++)for(let j = 0; j < this.field[i].length; j++){
            if (this.field[i + 1][j] === 0 && this.field[i][j] !== this.field[i + 1][j] || this.field[i + 1][j] === this.field[i][j] && this.field[i][j] !== 0) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".start");
const $09e991522ca7e64e$var$messageStartGame = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWinGame = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLoseGame = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const [...$09e991522ca7e64e$var$cells] = document.getElementsByClassName("field-cell");
function $09e991522ca7e64e$export$c446bd3f79853be8() {
    for(let i = 0; i < $09e991522ca7e64e$var$cells.length; i++){
        $09e991522ca7e64e$var$cells[i].className = "field-cell";
        if ($09e991522ca7e64e$var$game.field.flat()[i]) $09e991522ca7e64e$var$cells[i].classList.add(`field-cell--${$09e991522ca7e64e$var$game.field.flat()[i]}`);
    }
}
function $09e991522ca7e64e$export$65972ef3a64ea716() {
    for(let i = 0; i < $09e991522ca7e64e$var$cells.length; i++)[
        ...$09e991522ca7e64e$var$cells
    ][i].innerText = $09e991522ca7e64e$var$game.field.flat()[i] || "";
    $09e991522ca7e64e$var$gameScore.innerText = $09e991522ca7e64e$var$game.score;
}
function $09e991522ca7e64e$var$handleUpButtonClickAndUpdateField() {
    if (!$09e991522ca7e64e$var$game.checkVictory() && $09e991522ca7e64e$var$game.gameStatus === "playing") {
        $09e991522ca7e64e$var$game.moveUp();
        $09e991522ca7e64e$var$game.addingNumberToField();
        $09e991522ca7e64e$export$65972ef3a64ea716();
        $09e991522ca7e64e$export$c446bd3f79853be8();
    }
    if ($09e991522ca7e64e$var$game.checkVictory()) $09e991522ca7e64e$var$messageWinGame.classList.remove("hidden");
}
function $09e991522ca7e64e$var$handleDownButtonClickAndUpdateField() {
    if (!$09e991522ca7e64e$var$game.checkVictory() && $09e991522ca7e64e$var$game.gameStatus === "playing") {
        $09e991522ca7e64e$var$game.moveDown();
        $09e991522ca7e64e$var$game.addingNumberToField();
        $09e991522ca7e64e$export$65972ef3a64ea716();
        $09e991522ca7e64e$export$c446bd3f79853be8();
    }
    if ($09e991522ca7e64e$var$game.checkVictory()) $09e991522ca7e64e$var$messageWinGame.classList.remove("hidden");
}
function $09e991522ca7e64e$var$handleRightButtonClickAndUpdateField() {
    if (!$09e991522ca7e64e$var$game.checkVictory() && $09e991522ca7e64e$var$game.gameStatus === "playing") {
        $09e991522ca7e64e$var$game.moveRight();
        $09e991522ca7e64e$var$game.addingNumberToField();
        $09e991522ca7e64e$export$65972ef3a64ea716();
        $09e991522ca7e64e$export$c446bd3f79853be8();
    }
    if ($09e991522ca7e64e$var$game.checkVictory()) $09e991522ca7e64e$var$messageWinGame.classList.remove("hidden");
}
function $09e991522ca7e64e$var$handleLeftButtonClickAndUpdateField() {
    if (!$09e991522ca7e64e$var$game.checkVictory() && $09e991522ca7e64e$var$game.gameStatus === "playing") {
        $09e991522ca7e64e$var$game.moveLeft();
        $09e991522ca7e64e$var$game.addingNumberToField();
        $09e991522ca7e64e$export$65972ef3a64ea716();
        $09e991522ca7e64e$export$c446bd3f79853be8();
    }
    if ($09e991522ca7e64e$var$game.checkVictory()) $09e991522ca7e64e$var$messageWinGame.classList.remove("hidden");
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if (!$09e991522ca7e64e$var$startButton.classList.contains("start")) {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$messageLoseGame.classList.add("hidden");
        $09e991522ca7e64e$var$messageWinGame.classList.add("hidden");
        $09e991522ca7e64e$var$gameScore.innerText = $09e991522ca7e64e$var$game.score;
    }
    if ($09e991522ca7e64e$var$startButton.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.innerText = "Restart";
        $09e991522ca7e64e$var$messageStartGame.classList.add("hidden");
    }
    $09e991522ca7e64e$export$65972ef3a64ea716();
    $09e991522ca7e64e$export$c446bd3f79853be8();
});
document.addEventListener("keyup", (action)=>{
    const isEveryMoveBlocked = !$09e991522ca7e64e$var$game.canMoveCellsDown() && !$09e991522ca7e64e$var$game.canMoveCellsUp() && !$09e991522ca7e64e$var$game.canMoveCellsRight() && !$09e991522ca7e64e$var$game.canMoveCellsLeft();
    switch(action.key){
        case "ArrowUp":
            if ($09e991522ca7e64e$var$game.canMoveCellsUp()) $09e991522ca7e64e$var$handleUpButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $09e991522ca7e64e$var$game.gameStatus = "lose";
                $09e991522ca7e64e$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        case "ArrowLeft":
            if ($09e991522ca7e64e$var$game.canMoveCellsLeft()) $09e991522ca7e64e$var$handleLeftButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $09e991522ca7e64e$var$game.gameStatus = "lose";
                $09e991522ca7e64e$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        case "ArrowDown":
            if ($09e991522ca7e64e$var$game.canMoveCellsDown()) $09e991522ca7e64e$var$handleDownButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $09e991522ca7e64e$var$game.gameStatus = "lose";
                $09e991522ca7e64e$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        case "ArrowRight":
            if ($09e991522ca7e64e$var$game.canMoveCellsRight()) $09e991522ca7e64e$var$handleRightButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $09e991522ca7e64e$var$game.gameStatus = "lose";
                $09e991522ca7e64e$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        default:
            break;
    }
});


//# sourceMappingURL=index.2a9bddc7.js.map
